<template>
	<div>
		<div v-if="alertNoData" class="notification is-warning">
			{{ translations.admin_no_cards }}
		</div>
		<div class="notification is-warning">
			{{ translations.warning }}
		</div>
		<div class="columns order-action-bar is-hidden-touch">
			<div class="column is-narrow">
				<form @submit.prevent="makeSearch">
					<div class="field">
						<p class="control has-icons-left has-icons-right">
							<input class="input" type="text" name="search" v-model="search" :placeholder="translations.search">
							<span class="icon is-left">
								<i class="fa-solid fa-magnifying-glass"></i>
							</span>
							<span class="icon is-small is-right is-clickable" @click="clearSearch">
								<i class="fa-solid fa-xmark"></i>
							</span>
						</p>
					</div>
				</form>
			</div>
		</div>
		<table class="table is-fullwidth is-rowed is-sticky-header" :class="{'is-loading': renewal.loading}">
			<thead>
			<tr>
				<th>{{ translations.renew }}</th>
				<th>{{ translations.lastname }}</th>
				<th>{{ translations.firstname }}</th>
				<th>{{ translations.niss }}</th>
				<th>{{ translations.contract }}</th>
				<th>{{ translations.balances }}</th>
			</tr>
			</thead>
			<tbody>
			<tr v-if="renewal.data.length === 0">
				<td colspan="6">{{ translations.no_data }}</td>
			</tr>
			<tr v-for="(user, key) in renewal.data" :class="lineClassName(user)">
				<td>
						<span
								class="tooltip is-tooltip-right"
								:data-tooltip="translations.cardHolderStatus [ user.cardHolderStatus ]">
							<input
									@click="toggleUserRenewStatus(key, user, false)"
									type="checkbox"
									v-model="user.mustRenew"
									class="is-checkradio"
									:class="checkboxClassName(user)"
									:id="'toggle-cardstatus' + key"
									:disabled="canEditUserStatus(user)"
							>
							<label
									:for="'toggle-cardstatus' + key"
							></label>
						</span>
					<span
							v-if="!user.hasContract && parseInt(user.totalBalance) > 0"
							class="has-text-emv tooltip is-tooltip-multiline is-tooltip-right is-tooltip-warning"
							:data-tooltip="translations.tooltip_ex_employee"
					>
							<i class="fa-solid fa-triangle-exclamation"></i>
						</span>
				</td>
				<td><a @click="redirectToBenef(user.id)">{{ user.lastname }}</a></td>
				<td>{{ user.firstname }}</td>
				<td>{{ user.niss }}</td>
				<td>
					<div class="field">
						<input
								:id="'contract-'+user.id"
								:ref="'contract-'+user.id"
								type="checkbox"
								class="switch is-rounded is-success is-small"
								v-model="user.hasContract"
								:disabled="user.disable_update_contract === true"
						>
						<label :for="'switch-' + user.id" @click.prevent="changeContract(key, user)"></label>
						<span v-if="user.hasContract">{{ translations.contract_active }}</span>
						<span v-else>{{ translations.contract_inactive }}</span>
					</div>
				</td>
				<td>{{ user.totalBalance }}&nbsp;&euro;&nbsp;<a @click="showBalanceDetail(user.id)"><i class="fa-solid fa-circle-info"></i></a></td>
			</tr>
			</tbody>
		</table>

		<simple-modal
				:display="detailedBalances.display"
				@close="detailedBalances.display = false"
		>
			<template>
				<div class="panel has-border has-no-border-mobile is-marged-left-mobile is-marged-right-mobile">
					<div class="content-block has-content-separated-rows has-text-weight-bold is-hidden-touch">
						<div class="columns" v-for="balance, product in detailedBalances.data">
							<div class="column is-uppercase is-size-6" :class="className(product)">
							<span class="icon is-vertical-align is-medium">
								<i class="monizze-icon" :class="classIconName(product)"></i>
							</span>
								&nbsp;{{ translations.products[ product ] }}
							</div>
							<div class="column is-narrow has-text-right">
								{{ balance|format_money }}&nbsp;&euro;
							</div>
						</div>
						<div v-if="detailedBalances.length === 0">
							{{ translations.no_product }}
						</div>
					</div>
					<div class="is-hidden-desktop is-hidden-tablet columns is-mobile is-padded-right is-fixed-bottom-touch is-padded-bottom-desktop">
						<div class="column is-one-third-mobile" v-for="balance, product in detailedBalances.data">
							<div class="columns is-mobile is-size-7">
								<div class="column is-two-thirds has-text-right is-marged-top-mobile">
									<div class="columns">
										<div class="column is-paddingless">
											{{  translations.products[ product ] }}
										</div>
										<div class="column is-paddingless has-text-weight-bold">
											{{ balance|format_money }}&nbsp;&euro;
										</div>
									</div>
								</div>
								<div class="column is-one-third">
								<span class="icon is-vertical-align is-medium">
									<i class="monizze-icon" :class="classIconName(product)"></i>
								</span>
								</div>
							</div>
						</div>
					</div>
					<div v-if="detailedBalances.length === 0">
						{{ translations.no_product }}
					</div>
				</div>
			</template>
		</simple-modal>
	</div>
</template>

<script>
import {ApiMonizze} from '../api-monizze';
import {LoaderState} from "../api-monizze";

export default {
	name: "card-order-overview",
	data: function ()
	{
		return {
			renewal: {
				data: [],
				loading: true,
			},
			detailedBalances: {
				data: [],
				display: false,
			},
			defaultAcceptStatuses: [
				'Authorized by default',
			],
			greenStatuses: [
				'Authorized by customer',
				'Authorized by customer care',
			],
			defaultRejectStatuses: [
				'Rejected by default',
			],
			redStatuses: [
				'Rejected by customer',
				'Fired by customer',
				'Rejected by customer care',
				'Fired by customer care',
			],
			search: '',
			alertNoData: false,
		}
	},
	props:
		{
			urls: {
				type: Object,
				required: true,
			},
			executer: {
				type: String,
				required: true,
			},
			translations: {
				type: Object,
				required: true,
			},
			canEdit: {
				type: Boolean,
				required: true,
			},
			platform: {
				type: String,
				required: true,
			},
			customerId: {
				type: String,
				required: false,
			}
		},
	created()
	{
		this.loadData();
	},
	methods:
		{
			classIconName: function (product)
			{
				return 'monizze-icon-product-' + product;
			},
			className: function (product)
			{
				return 'monizze-product-' + product + '-color';
			},
			checkboxClassName: function(user)
			{
				var className = '';

				if (user.mustRenew)
				{
					className += 'has-background-color ';

					if (this.greenStatuses.includes(user.cardHolderStatus) || this.defaultAcceptStatuses.includes(user.cardHolderStatus))
					{
						className += 'is-success';
					}
				}
				else
				{
					className += 'is-danger';
				}

				return className;
			},
			lineClassName: function(user)
			{
				var className = '';

				if (this.greenStatuses.includes(user.cardHolderStatus))
				{
					className += 'has-background-green-light';
				}
				else if (this.defaultAcceptStatuses.includes(user.cardHolderStatus))
				{
					className += 'has-background-green-lighter';
				}
				else if (this.defaultRejectStatuses.includes(user.cardHolderStatus))
				{
					className += 'has-background-red-lighter';
				}
				else if (this.redStatuses.includes(user.cardHolderStatus))
				{
					className += 'has-background-red-light';
				}
				return className;
			},
			toggleUserRenewStatus: function (key, user, isFired)
			{
				var status = '';

				user.disable_update_cardholderstatus = true;

				self = this

				if (isFired)
				{
					status = 'fired-by-';
				}
				else
				{
					status = user.mustRenew ? 'rejected-by-' : 'authorized-by-';
				}
				status += this.$props.executer;

				if (this.$props.platform === 'client-area')
				{
					var api = new ApiMonizze();
					api.postDataFromApi(
						this.urls.toggleUserStatus.replace(':userId:', user.id),
						{
							newStatus: status
						},
						function (data) {
							if (data.statusUpdated === true)
							{
								user.cardHolderStatus = data.newStatus;
								self.$emit('updated', user)
							}
							else
							{
								user.mustRenew = !user.mustRenew;
							}
							user.disable_update_cardholderstatus = false;
						}
					);
				}
				else
				{
					axios
						.post(
							this.urls.toggleUserStatus
								.replace(':customerId:', this.$props.customerId)
								.replace(':userId:', user.id),
							{
								newStatus: status
							})
						.then(
							function (data) {
								if (data.data.data.statusUpdated === true)
								{
									user.cardHolderStatus = data.data.data.newStatus;
									self.$emit('updated', user)
								}
								else
								{
									user.mustRenew = !user.mustRenew;
								}
								user.disable_update_cardholderstatus = false;
							}
						);
				}
			},
			changeContract: function (key, user)
			{
				var hasContract = user.hasContract,
					method = hasContract ? 'fire' : 'unfire';

				user.disable_update_contract = true;

				if (this.$props.platform === 'client-area')
				{
					var api = new ApiMonizze();
					api.postDataFromApi(
						this.urls.userContractStatus
							.replace(':userId:', user.id)
							.replace(':method:', method),
						{},
						function () {
							user.hasContract = !hasContract;
							user.disable_update_contract = false;
						}
					);
				}
				else
				{
					axios
						.post(
							this.urls.userContractStatus
								.replace(':customerId:', this.$props.customerId)
								.replace(':userId:', user.id)
								.replace(':method:', method)
						)
						.then(
							function()
							{
								user.hasContract = !hasContract;
								user.disable_update_contract = false;
							}
						);
				}

				if (user.mustRenew && method === 'fire')
				{
					this.toggleUserRenewStatus(key, user, true);
				}
			},
			showBalanceDetail: function (id)
			{
				if (this.$props.platform === 'client-area')
				{
					var apiBalances = new ApiMonizze(new LoaderState(this.renewal));

					apiBalances.getDataFromApi(
						this.$props.urls.balances.replace(':userId:', id),
						(data) => {
							this.detailedBalances.data = data;
							this.detailedBalances.display = true;
						}
					);
				}
				else
				{
					var loader = new LoaderState(this.renewal);
					loader.setLoadingState(true);

					axios
						.get(
							this.$props.urls.balances
								.replace(':customerId:', this.$props.customerId)
								.replace(':userId:', id)
						)
						.then((data) => {
							this.detailedBalances.data = data.data.data;
							this.detailedBalances.display = true;
							loader.setLoadingState(false);
						});
				}
			},
			loadData: function (searchString)
			{
				let url = this.$props.urls.loadData;

				if (searchString)
				{
					url += '?search=' + searchString;
				}

				if (this.$props.platform === 'client-area')
				{
					(new ApiMonizze(new LoaderState(this.renewal)))
						.getDataFromApi(
							url,
							((data) => {
								if (data !== undefined) {
									if (data.cards.length) {
										this.renewal.data = data.cards.map(obj => ({
											...obj,
											disable_update_contract: false,
											disable_update_cardholderstatus: false
										}));
										data.cards.forEach(card => this.$emit('updated', card))
									} else {
										this.alertNoData = true;
									}
									this.$emit('update-data-length', data.cards.length);
								}
							})
						);
				}
				else
				{
					var loader = new LoaderState(this.renewal);
					loader.setLoadingState(true);
					axios
						.get(
							url.replace(':customerId:', this.$props.customerId)
						)
						.then((data) => {
							if (data.data.data !== undefined) {
								if (data.data.data.cards.length) {
									this.renewal.data = data.data.data.cards.map(obj => ({
										...obj,
										disable_update_contract: false,
										disable_update_cardholderstatus: false
									}));
								} else {
									this.alertNoData = true;
								}
								this.$emit('update-data-length', data.data.data.cards.length);
								loader.setLoadingState(false);
							}
						});
				}
			},
			canEditUserStatus: function(user)
			{
				return this.$props.canEdit === false || user.disable_update_cardholderstatus === true
			},
			makeSearch: function()
			{
				this.loadData(this.search)
			},
			clearSearch: function()
			{
				this.search = '';
				this.makeSearch();
			},
			redirectToBenef: function(userId)
			{
				window.location = this.$props.urls.redirectToBenef.replace(':userId:', userId);
			}
		},
}
</script>
